export default function initializeGalleryGrid() {
    document.querySelectorAll( '.block-gallery-grid' ).forEach( function( block ) {
        new Collapse(block);
    } );
}

class Collapse {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {
        console.log(this.block);
        const galleryButtons = this.block.querySelectorAll('.block-gallery-grid__button span');
        const galleryData = this.block.querySelector(`.block-gallery-grid__data`);

        galleryButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                if (this.classList.contains('block-gallery-grid__gallery__down')) {
                    this.classList.remove('d-block');
                    this.classList.add('d-none');
                    this.nextElementSibling.classList.remove('d-none');
                    this.nextElementSibling.classList.add('d-block');
                    galleryData.classList.toggle('block-gallery-grid__more');
                } else if (this.classList.contains('block-gallery-grid__gallery__up')) {
                    this.classList.remove('d-block');
                    this.classList.add('d-none');
                    this.previousElementSibling.classList.remove('d-none');
                    this.previousElementSibling.classList.add('d-block');
                    galleryData.classList.toggle('block-gallery-grid__more');
                }
            });
        });
    }
}
